/* eslint-disable no-plusplus */
import { useState } from "react";
import { Avatar, Box } from "@mui/material";
import ImageZoomModal from "../ImageZoomModal";

const CustomAvatar = ({
  src,
  alt,
  className,
  zoomable = false,
}: {
  className?: string | undefined;
  src: string | undefined;
  alt: string | undefined;
  zoomable?: boolean;
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  // Generate a random light background and matching dark text color based on the name
  function stringToColorAndText(str: string) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      // eslint-disable-next-line no-bitwise
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const h = Math.abs(hash) % 360;
    const s = 60 + (Math.abs(hash) % 20);
    const l = 80; // Always light background
    const bgColor = `hsl(${h},${s}%,${l}%)`;
    // Use same hue, high saturation, low lightness for dark text
    const textColor = `hsl(${h}, 80%, 20%)`;
    return { bgColor, textColor };
  }

  function stringAvatar(name: string) {
    const { bgColor, textColor } = stringToColorAndText(name);
    return {
      sx: {
        bgcolor: bgColor,
        color: `${textColor} !important`,
      },
      children: `${name[0]}${name[1]}`,
      bgColor,
      textColor,
    };
  }

  const avatarProps = stringAvatar(alt || "Customer Name");

  const handleAvatarClick = (e: React.MouseEvent) => {
    if (zoomable) {
      e.stopPropagation();
      e.preventDefault();
      setIsPreviewOpen(true);
    }
  };

  return (
    <>
      <Box
        onClick={handleAvatarClick}
        sx={{
          cursor: zoomable ? "zoom-in" : "default",
          display: "inline-flex",
          "&:hover": zoomable ? { opacity: 0.85 } : {},
          transition: "opacity 0.2s",
        }}
      >
        <Avatar
          src={src}
          alt={alt}
          sx={{
            ...avatarProps.sx,
            width: 40,
            height: 40,
            fontSize: 16,
            fontWeight: "bold",
            flexShrink: 0,
          }}
          className={className}
        >
          {avatarProps.children}
        </Avatar>
      </Box>

      {zoomable && (
        <ImageZoomModal
          open={isPreviewOpen}
          onClose={() => setIsPreviewOpen(false)}
          src={src}
          alt={alt}
          initials={avatarProps.children}
          bgColor={avatarProps.bgColor}
          textColor={avatarProps.textColor}
        />
      )}
    </>
  );
};

export default CustomAvatar;
